import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import avatar1 from '../img/avatar-logo.png';
import Cookies from 'universal-cookie';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { LogoutUser } from '../Redux/UsersDucks';

const Header = () => {
    const cookies = new Cookies();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const username = cookies.get('nombre');

    const onNavigate = (path) => {
        navigate(path);
    };

    const onClickButtonDelete = () => {
        dispatch(LogoutUser());
        navigate("/");
    };

    return (
        <Fragment>
            <header className="header">
                <div className="navbar navbar-expand-lg px-3 px-sm-4 py-2 bg-white shadow app-navbar">
                    <button
                        className="sidebar-toggle text-gray-500 me-4 me-lg-5 lead d-block d-sm-none"
                        onClick={() => onNavigate('/menu')} // Navega al menú al hacer clic
                    >
                        <Icon.List style={{ color: "black", fontSize: '20px' }} />
                    </button>

                    <button
                        className="navbar-brand fw-bold text-uppercase text-base"
                        onClick={() => onNavigate('/Inicio')}
                        style={{ background: 'none', border: 'none', outline: 'none' }} // Estilos para quitar el borde
                    >
                        <span className="d-none d-brand-partial">
                            <img src="/logo3.png" width="70px" alt="Nuevo Logo" />
                        </span>
                    </button>

                    <div className="ms-auto d-flex align-items-center list-unstyled mb-0 app-navbar-actions gap-2 gap-sm-3">
                        <div className="nav-item dropdown">
                            <span className="d-none d-md-inline">Hola {username}</span>
                        </div>
                        <div className="nav-item dropdown">
                            <button
                                className="btn p-0 border-0 bg-transparent d-flex align-items-center justify-content-center"
                                style={{ color: "#007BFF", background: 'none', border: 'none' }}
                                onClick={() => onNavigate('/Inicio')} // Navega al inicio al hacer clic en el avatar
                            >
                                <img className="avatar avatar-sm p-1" src={avatar1} alt="Avatar" />
                            </button>
                        </div>
                        <div className="nav-item dropdown">
                            <Button
                                variant="primary"
                                size="sm"
                                type="button"
                                onClick={onClickButtonDelete} // Cierra sesión y navega a la página principal
                            >
                                Cerrar Sesión
                            </Button>
                        </div>
                    </div>
                </div>
            </header>
        </Fragment>
    );
};

export default Header;
